import React from 'react';
import { useAuth as useClerkAuth, RedirectToSignIn } from '@clerk/clerk-react';

const ProtectedRoute = ({ children }) => {
  const { isLoaded, isSignedIn } = useClerkAuth();

  const isLoading = !isLoaded;
  const isAuthenticated = isSignedIn;

  if (isLoading) {
    return <div style={{ textAlign: 'center', marginTop: '2rem' }}>Loading...</div>;
  }

  if (!isAuthenticated) {
    // Prefer Clerk's sign-in flow on the home page
    return <RedirectToSignIn signInUrl="/" afterSignInUrl="/dashboard" />;
  }

  return children;
};

export default ProtectedRoute;